/** Tab order aligned with Naturals Signature / Bespoke rate cards. */
const CATEGORY_TAB_ORDER = [
  'hair trim & tresses',
  'signature haircuts',
  'hair wash & blow dry',
  'hair cuts',
  'classic cuts',
  'advance cuts',
  'kids cut',
  'hair color',
  'hair colouring',
  'hair coloring',
  'grey coverage',
  'trendy colors',
  'colouring & highlights',
  'hair styling',
  'wash & styling',
  'hair treatments',
  'protein treatments',
  'hair & scalp rituals',
  'executive shave',
  'skin care',
  'skincare',
  'facials',
  'detan | bleach',
  'nail care',
  'waxing',
  'massage',
  'rest & relax',
  'spa rituals',
  'general',
];

function tabSortKey(label) {
  const low = String(label || '').trim().toLowerCase();
  const idx = CATEGORY_TAB_ORDER.indexOf(low);
  return idx >= 0 ? idx : CATEGORY_TAB_ORDER.length + low.charCodeAt(0);
}

function displayCategory(svc) {
  const cat = String(svc?.category || '').trim();
  return cat || 'General';
}

/**
 * Group franchise catalog rows into service-session tabs.
 * @param {object[]} services
 * @param {{ omitGenderInTabs?: boolean }} options — when catalog is already gender-filtered (kiosk guest)
 */
export function groupServices(services, options = {}) {
  const { omitGenderInTabs = true } = options;
  const list = services || [];
  const hasCategory = list.some((svc) => String(svc?.category || '').trim());
  if (!hasCategory) {
    return [{ category: '', items: list }];
  }
  const map = new Map();
  for (const svc of list) {
    const cat = displayCategory(svc);
    const gender = String(svc.gender || '').trim().toLowerCase();
    const label =
      omitGenderInTabs || !gender || gender === 'unisex'
        ? cat
        : `${cat} · ${gender === 'male' ? 'Men' : gender === 'female' ? 'Women' : gender}`;
    if (!map.has(label)) map.set(label, []);
    map.get(label).push(svc);
  }
  return Array.from(map.entries())
    .sort(([a], [b]) => tabSortKey(a) - tabSortKey(b) || a.localeCompare(b))
    .map(([category, items]) => ({ category, items }));
}
